import axios from 'axios';
import Cookies from 'js-cookie';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || "http://localhost:3333",
});

api.interceptors.request.use(
    function (config) {
        const token = Cookies.get('auth_token_ui');
        if (token) {
            config.headers['auth-token-ui'] = token;
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default api;
